import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ch0004',
    ecrans: ['00-2']
});
